import React, { Fragment, useEffect, useState } from 'react';

import '../App.scss';

//Components
import Navbar from '../components/Navbar';
import Banner from '../components/Banner';
import PymesContent from '../components/PymesContent';
import FormSearch from '../components/FormSearch';
import Footer from '../components/Footer';
import CategoryCardContent from '../components/CategoryCardContent';

//Redux
import {resetParams} from '../store/params/action';
import {connect} from 'react-redux';

function Landing(props) {

  const [loc, setLoc] = useState('');
  const [search, setSearch] = useState({
    query: '',
    location: ''
  });

  useEffect(() => {
    props.resetParams();
  }, [props]);

  return (
    <Fragment>
      <Navbar />
      <Banner />
      <FormSearch
        classForm={'col-lg-12 formSearch'}
        rowClass={''}
        search={search}
        setSearch={setSearch}
        loc={loc}
        setLoc={setLoc}
        />
      <PymesContent
        limit={12}
        />
      <CategoryCardContent/>

      <div class="justify-content-center row">
        <div class="col-4 mb-5 blue-box" style={{minWidth: "625px"}}>
          <div class="col-12">
              <p class="font_700 f11">¿Quieres que te avisemos sobre los próximos días Compra Pyme?</p>
          </div>
          
          <div class="col-12">
              <input type="text" name="email" id="email" class="blue-in f11" placeholder="Ingresa tu correo electrónico"/>
              <input type="button" name="emailsubmit" id="emailemailsubmit" class="blue-btn" value="Enviar"/>
          </div>
        </div>
      </div>
      
      <Footer />
    </Fragment>
  );
}

export default connect(null, {resetParams})(Landing);
